/** @jsx h */
import { useRef, useState, useEffect } from 'preact/hooks';
import { Fragment } from 'preact';
import { labels } from '../../config';

const SearchInput = ({
  query,
  label,
  numericRangeFilterObj,
  triggerAjaxSubmit,
  pluginNamespace,
  isReset,
  toggleLoadingAnimation,
  updateUserCoordinates,
  placeholder,
  coordinatesApi,
  range,
  noCoordinatesFound,
  resetFilters,
}) => {
  const [showClearOption, setShowClearOption] = useState(false);
  const searchInputEl = useRef(null);
  const [isInitialRender, setIsInitialRender] = useState(true);

  useEffect(() => {
    if (isInitialRender) searchInputEl.current.focus();
    setIsInitialRender(false);
  });

  useEffect(() => {
    searchInputEl.current.value = query;
    setShowClearOption(!!query);
  }, [query]);

  useEffect(() => {
    // add custom ajaxtrigger on enter
    searchInputEl.current.addEventListener('keydown', e => {
      if (e.key === 'Enter') {
        e.preventDefault();
        triggerAjaxSubmit();
      }
    });
  });

  function handleInputChange() {
    if (searchInputEl && searchInputEl.current) {
      const value = searchInputEl.current.value;
      setShowClearOption(!!value);
    }
  }

  function clearInput(e) {
    e.preventDefault();
    searchInputEl.current.focus();
    setShowClearOption(false);
    resetFilters([`${pluginNamespace}[q]`]);
  }

  return (
    <Fragment>
      <div className="map__search-input">
        <div class="searchbar searchbar--map">
          <input
            id="searchbar__input"
            className="searchbar__input"
            data-main-input
            name={`${pluginNamespace}[q]`}
            ref={searchInputEl}
            onChange={handleInputChange}
            autocomplete="off"
            placeholder={placeholder || labels.search.placeholder || ''}
            type="text"
            aria-describedby={
              noCoordinatesFound ? 'desc-no-coordinates-found' : null
            }
            aria-invalid={noCoordinatesFound ? true : null}
          />
          <label
            htmlFor="searchbar__input"
            className="searchbar__input-label sr-only"
          >
            {labels.search.searchField}
          </label>
          {showClearOption && (
            <button
              class="searchbar__button search__searchbar-button--clear"
              type="button"
              onClick={clearInput}
              aria-controls="searchbar__input"
            >
              <span className="styled-button__text sr-only">
                {labels.search.clearSearchField}
              </span>
              <span className="styled-button__icon icon icon--close">
                <svg className="icon__svg" role="img" aria-hidden="true">
                  <use href="#icon-close" />
                </svg>
              </span>
            </button>
          )}
          <button class="searchbar__button" type="submit">
            <span className="styled-button__text sr-only">
              {labels.search.submit}
            </span>
            <span className="styled-button__icon icon icon--search">
              <svg className="icon__svg" role="img" aria-hidden="true">
                <use href="#icon-search" />
              </svg>
            </span>
          </button>
          {noCoordinatesFound && (
            <p class="map__search-input-message" id="desc-no-coordinates-found">
              <span>{labels.map.noCoordsFound || ''}</span>
            </p>
          )}
        </div>
      </div>
    </Fragment>
  );
};

export default SearchInput;
